import { useCallback, useEffect, useState } from 'react'

import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Card from '@mui/material/Card'
import Container from '@mui/material/Container'

import { Helmet } from 'react-helmet-async'
import Iconify from 'src/components/iconify'
import { paths } from 'src/routes/paths'
import { useSearchParams } from 'src/routes/hook'
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/custom-breadcrumbs'
import AccountGeneral from './account-general'
import AccountSecurity from './account-security'

const TABS = [
  {
    value: 'general',
    label: 'Perfil',
    icon: <Iconify icon='solar:user-id-bold-duotone' width={22} />,
  },
  {
    value: 'security',
    label: 'Segurança',
    icon: <Iconify icon='solar:shield-keyhole-bold-duotone' width={22} />,
  },
]

export default function SettingsPage() {
  const searchParams = useSearchParams()
  const initialTab = searchParams.get('tab') === 'security' ? 'security' : 'general'
  const [currentTab, setCurrentTab] = useState(initialTab)

  useEffect(() => {
    const tab = searchParams.get('tab')
    if (tab === 'security' || tab === 'general') {
      setCurrentTab(tab)
    }
  }, [searchParams])

  const handleChangeTab = useCallback((event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue)
  }, [])

  return (
    <>
      <Helmet>
        <title>Configurações</title>
      </Helmet>
      <Container maxWidth='lg'>
        <CustomBreadcrumbs
          heading='Configurações'
          links={[{ name: 'Início', href: paths.dashboard.root }, { name: 'Configurações' }]}
          sx={{ mb: { xs: 3, md: 4 } }}
        />

        <Card sx={{ mb: 3, borderRadius: 2, overflow: 'hidden' }}>
          <Tabs
            value={currentTab}
            onChange={handleChangeTab}
            variant='scrollable'
            scrollButtons='auto'
            sx={{
              px: { xs: 1, md: 2 },
              '& .MuiTab-root': {
                minHeight: 56,
                fontWeight: 600,
                textTransform: 'none',
              },
            }}
          >
            {TABS.map((tab) => (
              <Tab
                key={tab.value}
                value={tab.value}
                label={tab.label}
                icon={tab.icon}
                iconPosition='start'
              />
            ))}
          </Tabs>
        </Card>

        {currentTab === 'general' && <AccountGeneral />}
        {currentTab === 'security' && <AccountSecurity />}
      </Container>
    </>
  )
}
